import { render } from "./FinishedView.vue?vue&type=template&id=be237cac&scoped=true"
import script from "./FinishedView.vue?vue&type=script&lang=js"
export * from "./FinishedView.vue?vue&type=script&lang=js"

import "./FinishedView.vue?vue&type=style&index=0&id=be237cac&lang=less&scoped=true"

import exportComponent from "/home/lyramdc/Projects/face/ACE-face-name-test/v-face-memory/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be237cac"]])

export default __exports__